import { createReducer } from "utilities";
import * as TYPES from "./constants";
import { normalize } from "utilities";

const initialState = {
  results: normalize(),
  fetching: false,
  pending: {},
  error: null,
};

const mapIds = (ids, val) =>
  ids.reduce((acc, id) => {
    acc[id] = val;
    return acc;
  }, {});

const reducer = createReducer(initialState, {
  [TYPES.REQUEST](state, { ids }) {
    return {
      ...state,
      fetching: true,
      pending: {
        ...state.pending,
        ...mapIds(ids, true),
      },
    };
  },
  [TYPES.FAILURE](state, { error, ids }) {
    return {
      ...state,
      fetching: false,
      error: error || {},
      pending: {
        ...state.pending,
        ...mapIds(ids, false),
      },
    };
  },
  [TYPES.SUCCESS](state, { companies }) {
    const normalized = normalize(companies);
    return {
      ...state,
      fetching: false,
      error: null,
      results: {
        ...state.results,
        elements: {
          ...state.results.elements,
          ...normalized.elements,
        },
        ids: [...state.results.ids, ...normalized.ids],
      },
      pending: {
        ...state.pending,
        ...companies.reduce((acc, company) => {
          acc[company.id] = false;
          return acc;
        }, {}),
      },
    };
  },
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/companies/reducer.js